import { render, staticRenderFns } from "./ProjectPayments.vue?vue&type=template&id=257167a0"
import script from "./ProjectPayments.vue?vue&type=script&lang=js"
export * from "./ProjectPayments.vue?vue&type=script&lang=js"
import style0 from "./ProjectPayments.vue?vue&type=style&index=0&id=257167a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports